import storage from 'utils/storage'
import signin from '../signin'
import entities from 'entities'
import jwt_decode from 'jwt-decode'

const toISODate = (str) => {
  return str.split('/').reverse().join('-')
}

const checkGroupsSelected = (groups) => {
  return groups && groups.length !== 0
}

const create = ({ groupsSelected }) => {
  const sessionGroupsSelected = storage.session.getItem('groups_selected')

  const groupsSelectedVerified = checkGroupsSelected(groupsSelected)
    ? groupsSelected
    : sessionGroupsSelected

  const agreements = groupsSelectedVerified?.map((group) => ({
    debt_group_id: group.id,
    payment_option_id: group.dueDateSelected.payment.id,
    payment_day: toISODate(group.dueDateSelected.date),
  }))

  if (agreements?.length) {
    return signin().then(({ http }) => {
      let sessionId = storage.session.getItem('session_id')

      try {
        const sessionToken = storage.session.getItem('session_token')
        let decoded = jwt_decode(sessionToken)
        decoded = JSON.parse(decoded.data)
        sessionId = sessionId || decoded.session_uuid
      } catch {
        sessionId = storage.session.getItem('session_id')
      }

      return http
        .post(`session/${sessionId}/agreements/`, {
          agreements,
        })
        .then((data) => {
          const dataAgreements = data.agreements.map(entities.Agreement)
          const whatsappSentAuto = data.whatsapp_sent || false
          const leadData = data.lead_data || {}
          storage.session.setItem('agreements', dataAgreements)
          storage.session.setItem('whatsapp_sent_auto', whatsappSentAuto)
          storage.session.setItem('lead_data_contact', leadData)
          return dataAgreements
        })
    })
  } else {
    return Promise.reject([])
  }
}

const getDetails = () => {
  const sessionId = storage.session.getItem('session_id')

  return signin().then(({ http }) => {
    return http.get(`session/${sessionId}/agreements/`).then((data) => {
      const agreementsDetails = data?.agreement_details?.map(
        entities.AgreementDetails
      )
      storage.session.setItem('agreements-details', agreementsDetails)
      return agreementsDetails
    })
  })
}

// Essa função é utilizada para checar se o lead veio de cartões e tem um optin_selected(algum cartão que ele quer aprovação)
const getOptinSelected = () => {
  const sessionId = storage.session.getItem('session_id')

  return signin().then(({ http }) => {
    return http.get(`session/${sessionId}/agreements/`).then((data) => {
      const agreementsDetails = data.agreement_details
        ? data.optin_selected
        : false
      return agreementsDetails
    })
  })
}

export default {
  create,
  getDetails,
  getOptinSelected,
}
